// ADR manifest — order shown in the Administrator References list.
// Add one entry per ADR-XXX file under src/content/adr/.

import adr001 from "@/content/adr/001-knowledge-graph-storage.md?raw";
import adr002 from "@/content/adr/002-schema-model-option-c.md?raw";
import adr003 from "@/content/adr/003-hybrid-ranking.md?raw";

export type AdrEntry = {
  id: string;
  number: string;
  title: string;
  status: "Accepted" | "Proposed" | "Superseded";
  date: string;
  body: string;
};

export const ADRS: AdrEntry[] = [
  {
    id: "001-knowledge-graph-storage",
    number: "ADR-001",
    title: "Knowledge graph storage",
    status: "Accepted",
    date: "2026-05-19",
    body: adr001,
  },
  {
    id: "002-schema-model-option-c",
    number: "ADR-002",
    title: "Schema model — numeric tier, array discipline/level",
    status: "Accepted",
    date: "2026-05-19",
    body: adr002,
  },
  {
    id: "003-hybrid-ranking",
    number: "ADR-003",
    title: "Hybrid ranking for match_kg_nodes",
    status: "Accepted",
    date: "2026-05-19",
    body: adr003,
  },
];

export function getAdr(id: string): AdrEntry | undefined {
  return ADRS.find((a) => a.id === id);
}
